import { useAppDispatch } from '../grid/reduxStore/Store';
import { useSocketClient } from '../../../providers/SocketContext';
import { useCurrentUser } from '../../../providers/UserProvider';
import { useCheckDocumentLockStatus } from 'components/editor/hooks/useCheckDocumentLockStatus';
import { UndoRedoManagerCommandVersion } from '../UndoRedo/UndoRedoManagerCommandVersion';
import { SignatureUpdatedCommand } from '../UndoRedo/SignatureUpdatedCommand';
import type { SignaturePropertyUpdate } from '../../../services/socket/SocketClient';

export function useSignatureUpdatedHandler() {
  const dispatch = useAppDispatch();
  const { socketClient } = useSocketClient();
  const { data } = useCurrentUser();
  const checkDocumentLockStatus = useCheckDocumentLockStatus();
  const userId = data.id;

  return async (blockId: string, sectionId: string, oldProperties: SignaturePropertyUpdate, newProperties: SignaturePropertyUpdate) => {
    const undoRedoManager = UndoRedoManagerCommandVersion.getUndoRedoManager();
    const command = new SignatureUpdatedCommand(blockId, sectionId, oldProperties, newProperties, {
      dispatch,
      socketClient,
      userId,
      checkDocumentLockStatus,
    });
    const success = await command.redo();
    if (success) {
      undoRedoManager.pushUndoRedoCommands(command);
    }
  };
}
